// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileUpload-adminProfileRemoveBtnContainer-yIXmB {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    margin-top: 12px;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: normal;
    font-weight: 400;
    text-align: center;
}

.profileUpload-adminProfileRemoveBtn-eyt4X,
.profileUpload-adminProfileRemoveBtn-eyt4X:hover,
.profileUpload-adminProfileRemoveBtn-eyt4X:focus {
    color: var(--secondary-bg);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/helpers/EditProfileInfo/profileUpload.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;IAGI,0BAA0B;IAC1B,eAAe;AACnB","sourcesContent":[".adminProfileRemoveBtnContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 12px;\n    margin-bottom: 20px;\n    font-size: 16px;\n    line-height: normal;\n    font-weight: 400;\n    text-align: center;\n}\n\n.adminProfileRemoveBtn,\n.adminProfileRemoveBtn:hover,\n.adminProfileRemoveBtn:focus {\n    color: var(--secondary-bg);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminProfileRemoveBtnContainer": `profileUpload-adminProfileRemoveBtnContainer-yIXmB`,
	"adminProfileRemoveBtn": `profileUpload-adminProfileRemoveBtn-eyt4X`
};
module.exports = ___CSS_LOADER_EXPORT___;
